import {
  useGetAdminMessagingUnreadSummary,
  useGetMessagingUnreadSummary,
} from '../../../api/generated/messaging/messaging'

export type MessagingUnreadSurface = 'admin' | 'seller' | 'supply'

export function useMessagingUnread(
  surface: MessagingUnreadSurface,
  enabled: boolean,
) {
  const admin = useGetAdminMessagingUnreadSummary({
    query: {
      enabled: enabled && surface === 'admin',
      retry: false,
      refetchInterval: 60_000, // fallback only: realtime events invalidate this query
      refetchOnWindowFocus: true,
    },
  })
  const tenant = useGetMessagingUnreadSummary({
    query: {
      enabled: enabled && surface !== 'admin',
      retry: false,
      refetchInterval: 60_000, // fallback only: realtime events invalidate this query
      refetchOnWindowFocus: true,
    },
  })
  const response = surface === 'admin' ? admin.data : tenant.data
  const summary = response?.status === 200 ? response.data : null

  return {
    unreadMessages: summary?.unread_messages ?? 0,
    unreadConversations: summary?.unread_conversations ?? 0,
    isRealtimeFallbackPolling: enabled,
  }
}
